const openWholesaleButtons = document.querySelectorAll('.js-open-wholesale-popup');
const closeWholesaleButton = document.querySelector('.js-close-wholesale-popup');
const wholesalePopup = document.getElementById('wholesalePopupInfo');
const wholesaleBackdrop = document.getElementById('wholesalePopupBackdrop');
const wholesalePopupTitle = document.querySelector('.js-wholesale-popup-title');
const wholesalePopupContent = document.querySelector('.js-wholesale-popup-content');

openWholesaleButtons.forEach(function (button) {
  button.addEventListener('click', function () {
    const info = JSON.parse(button.dataset.moreInfo);

    // Title
    wholesalePopupTitle.textContent = info.title;

    // Replace line breaks with <br>
    let htmlWithFormatting = info.data.replace(/\n/g, '<br>');

    // Replace '---' with divider div
    htmlWithFormatting = htmlWithFormatting.replace(/---/g, '<div class="wholesale-popup-divider"></div>');

    // Inject into popup
    wholesalePopupContent.innerHTML = htmlWithFormatting;

    wholesalePopup.classList.add('show');
    wholesaleBackdrop.classList.add('show');
  });
});

closeWholesaleButton.addEventListener('click', function () {
  wholesalePopup.classList.remove('show');
  wholesaleBackdrop.classList.remove('show');
});

window.addEventListener('click', function (event) {
  if (event.target === wholesaleBackdrop) {
    wholesalePopup.classList.remove('show');
    wholesaleBackdrop.classList.remove('show');
  }
});
